import React, { Component } from "react"
import { NavLink } from "react-router-dom"
import { Disc, X, Circle } from "react-feather"
import classnames from "classnames"
import imgLogo from "../../../../assets/img/logo/logo.png";
import { useSelector } from "react-redux"

class SidebarHeader extends Component {
  render() {
    let {
      toggleSidebarMenu,
      activeTheme,
      collapsed,
      toggle,
      sidebarVisibility,
      menuShadow,
      localName,
    } = this.props

    return (
      <div className="navbar-header">
        <ul className="nav navbar-nav" >
          <li className="nav-item m-auto">
            <NavLink to="/" className="navbar-brand">
              <img src={imgLogo} alt="logo" className="nav-logo"/>
            </NavLink>
            {/* <div className="nav-header-info">
              <h6>{localName?.data?.role_description}</h6>
              {
                localName?.data?.role == "adminlocal" &&
                <h5>"{localName?.data?.local_name}"</h5>
              }
            </div> */}
          </li>
          {/* <li className="nav-item nav-toggle">
            <div className="nav-link modern-nav-toggle">
              {collapsed === false ? (
                <>
                </>
              ) : (
                  <Circle
                    onClick={() => {
                      toggleSidebarMenu(false)
                      toggle()
                    }}
                    className={classnames(
                      "toggle-icon icon-x d-none d-xl-block font-medium-4",
                      {
                        "text-primary": activeTheme === "primary",
                        "text-success": activeTheme === "success",
                        "text-danger": activeTheme === "danger",
                        "text-info": activeTheme === "info",
                        "text-warning": activeTheme === "warning",
                        "text-dark": activeTheme === "dark"
                      }
                    )}
                    size={20}
                  />
                )}
              <X
                onClick={sidebarVisibility}
                className={classnames(
                  "toggle-icon icon-x d-block d-xl-none font-medium-4",
                  {
                    "text-primary": activeTheme === "primary",
                    "text-success": activeTheme === "success",
                    "text-danger": activeTheme === "danger",
                    "text-info": activeTheme === "info",
                    "text-warning": activeTheme === "warning",
                    "text-dark": activeTheme === "dark"
                  }s
                )}
                size={20}
              />
            </div>
          </li> */}
        </ul>
        <div
          className={classnames("shadow-bottom", {
            "d-none": menuShadow === false
          })}
        />
      </div>
    )
  }
}

export default SidebarHeader
